var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SimpleCenteredPage',{attrs:{"narrow":"","id":"confirm-email-change-view"}},[_c(_setup.AccountEmailVerification,{attrs:{"token":_vm.token}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }